import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { useState, useEffect } from "react";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { msalInstance } from "@/authConfig";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Contracts from "@/pages/Contracts";
import LOA from "@/pages/LOA";
import Form470 from "@/pages/Form470";
import Form471 from "@/pages/Form471";
import Form486 from "@/pages/Form486";
import Invoices from "@/pages/Invoices";
import C2Budget from "@/pages/C2Budget";
import USACImport from "@/pages/USACImport";
import FRNLifecycle from "@/pages/FRNLifecycle";
import Deadlines from "@/pages/Deadlines";
import ClientTimeline from "@/pages/ClientTimeline";
import Reports from "@/pages/Reports";
import DigestPreview from "@/pages/DigestPreview";
import MultiYearContracts from "@/pages/MultiYearContracts";
import FRNStatus from "@/pages/FRNStatus";
import ClientFundingReport from "@/pages/ClientFundingReport";
import ClientEnrollment from "@/pages/ClientEnrollment";
import ClientContracts from "@/pages/ClientContracts";
import ClientInvoices from "@/pages/ClientInvoices";
import Report2027470 from "@/pages/Report2027470";
import Login from "@/pages/Login";

function ProtectedRoutes({ onLogout }) {
  return (
    <Layout onLogout={onLogout}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/enrollment" element={<ClientEnrollment />} />
        <Route path="/client-contracts" element={<ClientContracts />} />
        <Route path="/client-invoices" element={<ClientInvoices />} />
        <Route path="/contracts" element={<Contracts />} />
        <Route path="/loa" element={<LOA />} />
        <Route path="/forms/470" element={<Form470 />} />
        <Route path="/forms/471" element={<Form471 />} />
        <Route path="/forms/486" element={<Form486 />} />
        <Route path="/frn-status" element={<FRNStatus />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/c2-budget" element={<C2Budget />} />
        <Route path="/usac-import" element={<USACImport />} />
        <Route path="/frn-lifecycle" element={<FRNLifecycle />} />
        <Route path="/deadlines" element={<Deadlines />} />
        <Route path="/clients/:clientId/timeline" element={<ClientTimeline />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/reports/client-funding" element={<ClientFundingReport />} />
        <Route path="/reports/2027-470" element={<Report2027470 />} />
        <Route path="/digest" element={<DigestPreview />} />
        <Route path="/contracts/multi-year" element={<MultiYearContracts />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function AppContent() {
  const { accounts } = useMsal();
  const [jwtUser, setJwtUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Check for existing JWT token
    const token = localStorage.getItem("auth_token");
    const user = localStorage.getItem("auth_user");
    if (token && user) {
      try {
        setJwtUser(JSON.parse(user));
      } catch {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_user");
      }
    }
    setChecking(false);
  }, []);

  const isAuthenticated = accounts.length > 0 || jwtUser !== null;

  const handleLogin = (user) => {
    setJwtUser(user);
  };

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
    setJwtUser(null);
  };

  if (checking) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: "#F8F9FA" }}>
        <p style={{ fontSize: 13, color: "#6B7280" }}>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Login onLogin={handleLogin} />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <ProtectedRoutes onLogout={handleLogout} />
    </BrowserRouter>
  );
}

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <div className="App">
        <Toaster position="top-right" richColors />
        <AppContent />
      </div>
    </MsalProvider>
  );
}

export default App;
